import styled from "styled-components";
import { Link } from "gatsby";
import { palette } from "@interia/common/styles/global";
import { StaticImage } from "gatsby-plugin-image"
import { careerPalette } from "../../styles/global"
import { up, down } from 'styled-breakpoints';

type ScrollProps = {
  scroll: number
}

export const Wrapper = styled.header`
  padding: 0 7vw 0 7vw;
  width: calc(100vw - 14vw);
  background: ${careerPalette.primary};
  ${down('lg')}{
    display: none;
  }

`

export const Content = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
`


export const MenuWrapper = styled.nav`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-between;
`

export const ContentWrapper = styled.div`
  display: flex;
  :nth-child(1){
    justify-content: flex-start;
  }
  :nth-child(2){
    justify-content: flex-end;
  }
`

type MenuItemWrapperProps = {
  border?: string
  active?: boolean
  scroll: number,
}

export const MenuItemWrapper = styled.div<MenuItemWrapperProps>`
  transition: padding 0.5s;
  transition: border 0.1s;
  padding: ${props => props.scroll < 100 ? '50px 1.5vw 45px 1.5vw' : '30px 1.5vw 25px 1vw'};

  text-align: center;
  font-weight: 900;
  font-size: 1rem;
  ${down('xl')}{
    font-size: 0.9rem;
  }
  letter-spacing: 0px;
  border-bottom: ${props => props.border ? `7px solid ${props.active ? props.border : careerPalette.primary}` : "0px"};
  background-color: ${careerPalette.primary};
  color: ${palette.white};
  :hover{
    border-bottom: ${props => props.border ? `7px solid ${props.border}` : "0px"};
  }
`

type MenuItemProps = {
  outlined?: boolean
}

export const MenuItem = styled.span <MenuItemProps>`
  padding: ${props => props.outlined ? '10px 30px 7px 30px' : '10px 0 10px 0'} ;
  color: ${props => props.outlined ? careerPalette.primary : 'inherit'};
  text-transform: uppercase;
  text-decoration: none;
  background-color: ${props => props.outlined ? careerPalette.blue : 'inherit'};
  :hover{
    filter: brightness(${props => props.outlined ? '85%' : '100%'});
  }
`

